import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

export interface SendEmailDialogData {

}

@Component({
  selector: 'app-send-email-confirm-dialog',
  templateUrl: './send-email-confirm-dialog.component.html',
  styleUrls: ['./send-email-confirm-dialog.component.scss']
})
export class SendEmailConfirmDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SendEmailConfirmDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
  ) {
    this.form = fb.group({
      name: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      email: [null, Validators.compose([Validators.required, Validators.email, Validators.maxLength(255)])],
    });

    this.form.patchValue(data.form);

   }

  ngOnInit() {

  }

  send() {
    this.baseService.executeCommand<any>(this.data.createEmailFunction || 'portal_syspro_order_create_email', {
      email: this.data.email,
      to: this.form.value
    }).subscribe(response => {
      if (response.responseCode === 0) {
        this.dialogRef.close(true);
      }
    });
  }

}
